import Resource from './Resource';

export default class Token extends Resource{
	constructor( options = {} ){
		let {
			baseUrl = "",
			query = {}
		} = options;

		let config = {
			baseUrl: baseUrl,
			route: "token",
			version: "",
			query: query
		};

		super(config);
		return this;
	}

	get(){
		return this.request();
	}
}
